import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import DrawerModal from '../../components/shared/DrawerModal';
import { getIsVisibleModal, closeModal } from '../../redux/store/ui/common';
import styles from './UpdateAreaNameModal.styles';
import { useIntl } from 'react-intl';
import {
  selectSelectedArea,
  updateArea,
} from '../../redux/store/appData/areas';

const UpdateAreaNameModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const visibleModal = useSelector(getIsVisibleModal('updateAreaNameModal'));
  const selectedArea = useSelector(selectSelectedArea);

  const [name, setName] = useState(null) as any;

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(updateArea(selectedArea?.id, { name: name }));
    dispatch(closeModal('updateAreaNameModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('updateAreaNameModal'));
  };

  useEffect(() => {
    setName(null);
  }, [visibleModal]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('updateAreaNameModal'));
        }}
      >
        <div className="update-area-name-modal">
          <div className="update-area-name-wrapper">
            <p className="label">
              {intl.formatMessage({
                id: `fleetadmin.area.name`,
              })}
            </p>
            <Input
              placeholder={intl.formatMessage({
                id: `fleetadmin.area.name.placeholder`,
              })}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <Button
            className="submit-button"
            onClick={handleOnSubmit}
            disabled={!name}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateAreaNameModal;
